//引入接口文档
import req from '@/utils/req.js'

//问卷系统-问题更新
export function updateTitle(params) {
  return req.put("/admin/qs-question",params);
}
//问卷系统-复制某个问题
export function copyTitle(params) {
  return req.post("/admin/qs-question/copyQuestion",params);
}
//问卷系统-问题添加,并获取ID
export function addTitle(params) {
  return req.post("/admin/qs-question/insertReturnId",params);
}
//问卷系统-问题列表查询
export function titleList(params) {
  return req.post("/admin/qs-question/list",params);
}
//问卷系统-问题详情
export function titleDetails(params) {
  return req.get(`/admin/qs-question/${params.id}`);
}
//问卷系统-问题删除
export function deleteTitle(params) {
  return req.delete(`/admin/qs-question/${params.id}`);
}


//问卷系统-问题项更新
export function updateAnswerItem(params) {
  return req.put("/admin/qs-question-item",params);
}
//问卷系统-问题项添加,并获取ID
export function addAnswerItem(params) {
  return req.post("/admin/qs-question-item/insertReturnId",params);
}
//问卷系统-问题项列表查询
export function getAnswerItem(params) {
  return req.post("/admin/qs-question-item/list",params);
}
//问卷系统-问题项删除
export function deleteAnswerItem(params) {
  return req.delete(`/admin/qs-question-item/${params.id}`);
}

//问卷系统-点击题型保存整块题型
export function defaultInsertQuestion(params) {
  return req.post("/admin/qs-question/defaultInsertQuestion",params);
}

//问卷系统-跳转逻辑设置
export function updateQsQuestionBatch(params) {
  return req.post("/admin/qs-question-item/updateQsQuestionBatch",params);
}

//问卷系统-跳转逻辑获取
export function getQuestionLogicList(params) {
  return req.get(`/admin/qs-question-item/getQuestionLogicList/${params}`);
}

//问卷系统-批量修改问卷
export function updateQuestionBatch(params) {
  return req.post("/admin/qs-question/updateQuestionBatch",params);
}

// 平级联选题
//添加,并获取ID
export function addLevelItem(params) {
  return req.post("/admin/qs-question-item-linkage/insertReturnId",params);
}

//列表查询
export function queryLevelList(params) {
  return req.post("/admin/qs-question-item-linkage/list",params);
}

//更新
export function updateLevelItem(params) {
  return req.put("/admin/qs-question-item-linkage",params);
}

//删除
export function deleteLevelItem(params) {
  return req.delete(`/admin/qs-question-item-linkage/${params.id}`);
}

//重置选项
export function resetItemList(params) {
  return req.post("/admin/qs-question-item-linkage/resetItemList",params);
}

// 查看
//问卷系统-预览时获取问卷详情
export function getExamPaperDetail(params) {
  return req.get("/admin/qs-exam-paper/getExamPaperDetail",params);
}

//问卷系统-预览获取问卷下一题以及选项
export function nextQuestion(params) {
  return req.post("/admin/qs-exam-paper/nextQuestion",params);
}

//问卷系统-预览获取问卷上一题以及选项和答案
export function perQuestion(params) {
  return req.post("/admin/qs-exam-paper/perQuestion",params);
}

//保存问卷选项推送设置
export function saveQsQuestionItemPushList(params) {
  return req.post("/admin/qs-question-item-push/saveQsQuestionItemPushList",params);
}

//问卷分值推送设置表列表查询
export function queryPushSetPop(params) {
  return req.post("/admin/qs-question-item-push/list",params);
}

//问卷系统-问题详情
export function getQuestionDetial(params) {
  return req.post("/admin/qs-question/getQuestionDetial",params);
}

//问卷系统-复制问题到剪切板
export function copyQuestion(params) {
  return req.post(`/admin/qs-question/copyQuestion/${params.id}`,params);
}

//问卷系统-粘贴某个问题到某问卷
export function pasteQuestion(params) {
  return req.post(`/admin/qs-question/pasteQuestion/${params.id}/${params.sort}/${params.allSort}`,params);
}

//问卷系统-答题卡的题目项更新
export function updateQuestionItem(params) {
  return req.put(`/admin/qs-answer-sheet-question-item`,params);
}

//获取某次睡眠测评分析数据
export function getSleepScoreById(params) {
  return req.get(`/patient/qs-answer-sheet/getSleepScoreById/${params.id}`);
}

// ————不良反应————
//树形菜单(问卷用)
export function questionnaireTree(params) {
  return req.post("/admin/terminology/questionnaire-tree",params);
}

//不良反应表列表查询
export function getReactionList(params) {
  return req.post("/admin/adverse-reaction/list",params);
}

//不良反应现象表列表查询
export function getPhenomenonList(params) {
  return req.post("/admin/adverse-reaction-phenomenon/list",params);
}

//问卷系统-修改题目属性术语
export function updateQuestionTerms(params) {
  return req.put(`/admin/qs-question/property`,params);
}

//问卷系统-修改选项属性不良反应
export function updateQuestionReact(params) {
  return req.put(`/admin/qs-question-item/properties`,params);
}

//问卷系统-修改题目属性术语
export function updateNumQuestionReact(params) {
  return req.put(`/dsicm-data-base/feign/qs-question-item/addAdverseReaction`,params);
}

//问卷系统-修改是否记分
export function updateCountScore(params1,params2) {
  return req.put(`/admin/qs-exam-paper/updateCountScore?id=${params1}&isCountScore=${params2}`);
}

//问卷选项推送设置批量保存
export function saveBatch(params) {
  return req.post("/admin/qs-question-item-relate-push/saveBatch",params);
}

//问卷选项推送设置表列表查询
export function queryBatch(params) {
  return req.post("/admin/qs-question-item-relate-push/list",params);
}

//保存结论
export function saveConclusion(params) {
  return req.post("/admin/qs-exam-paper-score/saveConclusion",params);
}

//根据问卷Id获取结论
export function getConclusion(params) {
  return req.post(`/admin/qs-exam-paper-score/getConclusion/${params}`);
}

//保存整个问卷
export function saveConfig(params) {
  return req.post("/admin/qs-exam-paper/save",params);
}


// 复制剪切（多个）
export function copyQuestionList(params) {
  return req.post("/admin/qs-question/copyQuestionList",params,{loading: true});
}

// 粘贴
export function pasteQuestionList(params) {
  return req.post("/admin/qs-question/pasteQuestionList",params);
}

// 查询已复制的题目数据
export function getCopyQuestionList(params) {
  return req.post("/admin/qs-question/getCopyQuestionList",params);
}

// 修改问卷题目选项上下移动
export function updateQuestionItemBatch(params) {
  return req.post("/admin/qs-question-item/updateQuestionItemBatch",params);
}

// 修改问卷-加锁
export function lockExamPaper(params) {
  return req.get("/admin/qs-exam-paper/updateExamPaper/lock",params);
}

// 修改问卷-释放锁
export function unlockExamPaper(params) {
  return req.get("/admin/qs-exam-paper/updateExamPaper/unlock",params);
}

// 调用问卷列表
export function getSurveyFormList(params) {
  return req.post("/admin/qs-exam-paper/survey/page", params);
}

// 获取标准字段
export function searchStandardFieldList(params) {
  return req.get("/admin/standard-field/searchByName",params);
}

// 关联标准字段
export function updateStandardField(params) {
  return req.put("/admin/qs-question/updateStandardField",params);
}
